<template>
	<div>
			
			<div class="commonBox viewVisual" v-bind:class="{ active : isViewVisual }">
				<div>
					<div>
						
						<img :src="viewData.visual">
						
					</div>
				</div>
			</div>
			
			<div class="commonBox">
				<div>
					<div>
						
						<div class="mainInfo">
							<ul>
								<li class="title">• 꿈개발일</li>
								<li class="data">{{ viewData.date }}</li>
							</ul>
							<ul>
								<li class="title">• 개발언어</li>
								<li class="data">{{ viewData.code }}</li>
							</ul>
							<ul>
								<li class="title">• 꿈라이언트</li>
								<li class="data">{{ viewData.client }}</li>
							</ul>
							<ul>
								<li class="title">• 꿈개발자들</li>
								<li class="data">{{ viewData.people }}</li>
							</ul>
						</div>

						<div class="mainAbout">
							<p v-html="viewData.about"></p>
						</div>

						<div class="link" v-if="viewData.link">
							<a :href="viewData.link" target="_blank">사이트바로가기<img src="@/assets/img/icon_link.svg" class="hover"><img src="@/assets/img/icon_link_hover.svg" class="default"></a>
						</div>
						
					</div>
				</div>
			</div>
			
			<div class="commonBox moreInfo">
				<div>
					<div v-html="viewData.moreInfo">
						
					</div>
				</div>
			</div>
			
			<div class="commonBox">
				<div>
					<div>
						
						<div class="prev">
							<router-link to="/portfolio"><img src="@/assets/img/icon_left.svg" class="default"><img src="@/assets/img/icon_left_hover.svg" class="hover">포트폴리오 목록</router-link>
						</div>
						
					</div>
				</div>
			</div>
		
	</div>
</template>

<style>
	#portfolioView { width: 100%; float: left; }
	
	#portfolioView > .viewVisual > div { padding: 20px; }
	#portfolioView > .viewVisual > div > div { padding: 0; padding-bottom: 50%; background-color: #EEE; overflow: hidden; }
	#portfolioView > .viewVisual img { position: absolute; width: 110%; max-width: 110%; height: 110%; left: -5%; top: -5%; opacity: 0; transition: all 0.5s; }
	#portfolioView > .viewVisual.active img { width: 100%; height: 100%; left: 0; top: 0; opacity: 1; }
	
	#portfolioView .mainInfo { width: 100%; float: left; border: 1px solid #DDD; display: flex; }
	#portfolioView .mainInfo > ul { width: 25%; float: left; border-right: 1px solid #EAEAEA; padding: 30px 20px; }
	#portfolioView .mainInfo > ul:last-of-type { border-right: 0; }
	#portfolioView .mainInfo > ul > li { width: 100%; float: left; }
	#portfolioView .mainInfo > ul > li.title { color: #000; font-weight: 500; font-size: 12px; margin-bottom: 5px; }
	#portfolioView .mainInfo > ul > li.data { font-weight: 400; font-size: 13px; color: #000; letter-spacing: 0; }
	
	#portfolioView .link { width: 100%; float: left; padding: 20px 0; text-align: right; }
	#portfolioView .link > a { width: 160px; height: 50px; line-height: 48px; display: inline-block; color: #FFF; background-color: #0000C8; border: 1px solid #0000C8; font-weight: bold; transition: all 0.5s; text-align: left; padding: 0 20px; font-size: 13px; }
	#portfolioView .link > a > img { position: absolute; width: 14px; max-width: 14px; right: 20px; top: 50%; transform: translateY(-50%); transition: opacity 0.5s; margin-top: -2px; }
	#portfolioView .link > a > .default { opacity: 1; }
	#portfolioView .link > a > .hover { opacity: 0; }
	
	#portfolioView .mainAbout { width: 100%; float: left; padding: 20px; }
	#portfolioView .mainAbout > p { width: 100%; float: left; font-weight: 400; font-size: 18px; line-height: 26px; }
	
	#portfolioView > .moreInfo { width: 100%; float: left; }
	#portfolioView > .moreInfo > div > div > img { width: 100%; float: left; }
	#portfolioView > .moreInfo > div > div > video { width: 100%; float: left; }
	#portfolioView > .moreInfo > div > div > div { width: 100%; float: left; }
	#portfolioView > .moreInfo > div > div > div > p { width: 100%; float: left; font-size: 12px; color: #666; text-align: center; margin-top: 15px; margin-bottom: 50px; }
	
	#portfolioView .prev { width: 100%; float: left; text-align: left; margin-top: -20px; }
	#portfolioView .prev > a { width: 170px; height: 50px; line-height: 48px; display: inline-block; color: #000; background-color: #FFF; border: 1px solid #000; font-weight: bold; transition: all 0.5s; text-align: right; padding: 0 20px; font-size: 13px; }
	#portfolioView .prev > a > img { position: absolute; width: 20px; max-width: 20px; left: 20px; top: 50%; transform: translateY(-50%); transition: opacity 0.5s; }
	#portfolioView .prev > a > .default { opacity: 1; }
	#portfolioView .prev > a > .hover { opacity: 0; }
	
	@media (hover : hover){
		#portfolioView .link > a:hover { background-color: #FFF; color: #0000C8; }
		#portfolioView .link > a:hover > .default { opacity: 0; }
		#portfolioView .link > a:hover > .hover { opacity: 1; }
		
		#portfolioView .prev > a:hover { background-color: #000; color: #FFF; }
		#portfolioView .prev > a:hover > .default { opacity: 0; }
		#portfolioView .prev > a:hover > .hover { opacity: 1; }
	}
	
	@media (max-width: 700px){
		#portfolioView > .viewVisual > div { padding: 0; }
		
		#portfolioView .mainInfo { display: block; }
		#portfolioView .mainInfo > ul { width: 50%; height: 100px; border-bottom: 1px solid #EAEAEA; padding: 20px; }
		#portfolioView .mainInfo > ul:nth-of-type(2) { border-right: 0; }
		#portfolioView .mainInfo > ul:nth-of-type(3) { border-bottom: 0; }
		#portfolioView .mainInfo > ul:nth-of-type(4) { border-bottom: 0; }
		
		#portfolioView .link { padding-bottom: 0; }
		
		#portfolioView > .moreInfo > div > div { padding: 0; }
		#portfolioView > .moreInfo > div > div > p { margin-bottom: 30px; font-size: 11px; }
		
		#portfolioView .mainAbout > p { font-size: 14px; line-height: 18px; }
	}
</style>

<script>
	var $;
	
	export default {
		name : "portfolioView",
		data : function(){
			return {
				viewData : [],
				isViewVisual : false,
				topVisualTitle : "",
				topVisualSub : ""
			}
		},
		methods : {
			pageLoad : function(){
				$ = this;
				
				$.$parent.listShow = false;
				
				var frmData = new FormData();
				frmData.append("no", $.$route.params.no);
				
				$.$axios.post("//api.134340.kr/portfolio/view", frmData, { headers: $.$axiosHeader }).then(function(res){
					$.viewData = res.data.data;
					$.topVisualTitle = $.viewData.title;
					$.topVisualSub = $.viewData.sub;
					
					if(!$.topVisualTitle){
						$.$router.push("/");
						return false;
					}
					
					$.viewData.moreInfo = "";
					if($.viewData.info){
						for(var i = 0; i < $.viewData.info.length; i++){
							var row = $.viewData.info[i];

							switch(row.type){
								case "img" :
									$.viewData.moreInfo += "<img src='" + row.data + "'>";
									break;
								case "vid" :
									$.viewData.moreInfo += "<video src='" + row.data + "' controls></video>";
									break;
								case "word" :
									$.viewData.moreInfo += "<div><p>" + row.data + "</p></div>";
									break;
							}
						}
					}
					
					$.$parent.$parent.pageOpen();

					$.$parent.$parent.topVisualTitle = $.topVisualTitle;
					$.$parent.$parent.topVisualSub = $.topVisualSub;
				});
			}
		},
		mounted : function(){
			setTimeout(function(){
				$.isViewVisual = true;
			}, 1200);
		},
		beforeMount : function(){
			this.pageLoad();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/portfolioView.vue